import { atom } from "recoil";

export const authState = atom({
  key: "authState",
  default: null,
});

export const authReadyState = atom({
  key: "authReadyState",
  default: false,
});

export const widalInterpretationState = atom({
  key: "widalInterpretationState",
  default: null,
});
